import React, { useState, useRef, createRef } from "react";
import { ArrowLeft, ChevronDown } from "react-feather";
import Data from "./search1.json";

const ObFaq = () => {
  const [customAccordian, setCustomAccordian] = useState({
    active: -1,
  });

  const onClickHandler = (id) => {
    const current = customAccordian.active === id ? -1 : id;
    setCustomAccordian({
      active: current,
    });
  };

  return (
    <div className="mt-16 max-w-screen-xl mx-auto px-2 sm:px-6 lg:px-8">
      <a
        href="/#"
        className="mb-3 focus:outline-none -ml-3 backButtton flex hover:bg-blue-200 items-center px-4 py-2 rounded-md text-blue-700"
        style={{ width: "fit-content" }}
      >
        <ArrowLeft size="16" className="mr-2" />
        <span className="text-sm">Back to Help Center</span>
      </a>

      <h1 className="text-3xl font-bold">
        OneBill Frequently Asked Questions!
      </h1>
      <div className="my-16 text-gray-600">
        {Data.map((data, index) => (
          <div
            className="mb-20"
          >
             <h3 className="text-2xl font-bold mb-6" id={data.id}>{data.name}</h3>
            {data.children.map((subData, index) => (
              <div
                className="bg-white shadow-sm hover:shadow-lg hover:bg-gray-50 mb-6 rounded-lg transition-all duration-300 ease-in-out"
                onClick={() => onClickHandler(subData.id)}
              >
                <div className="cursor-pointer flex items-center justify-between p-4">
                  <span className="text-gray-800 font-semibold text-sm">
                    {" "}
                    {subData.title}
                  </span>
                  <span>
                    <ChevronDown
                      size="16"
                      strokeWidth="3"
                      className="text-gray-800 hover:text-red-800"
                    />
                  </span>
                </div>
                {subData.id === customAccordian.active ? (
                  <div className="pb-4 px-4 text-gray-800 text-sm leading-6">
                    {subData.description}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ObFaq;
